import { BordOneToneIcon } from 'bord-design-system';
import { bordColorTheme } from '../../../../../../../styles/styles.constants';
import './DescriptionItem.scss';

/** Spec unificada: string = texto, boolean = ícono check/xCircle, null = ícono xCircle */
export interface ISpec {
  label: string;
  value: string | boolean | null;
}

interface IDescriptionItem {
  spec: ISpec;
}

/**
 * Renderiza un ítem individual del grid de especificaciones del dispositivo:
 * muestra la etiqueta y el valor como texto o como ícono check/xCircle según el tipo.
 */
const DescriptionItem = ({ spec }: IDescriptionItem) => {
  const isIconValue = (value: string | boolean | null): value is boolean | null =>
    value === null || typeof value === 'boolean';

  return (
    <div className="descriptionItem">
      <div className="specLabel">{spec.label}</div>
      {isIconValue(spec.value) ? (
        <BordOneToneIcon
          variant={spec.value ? 'checkCircle' : 'xCircle'}
          standardSize={14}
          stroke={spec.value ? bordColorTheme.success.default : bordColorTheme.danger.fgPrimary}
        />
      ) : (
        <div className="specValue" title={spec.value}>
          {spec.value}
        </div>
      )}
    </div>
  );
};

export default DescriptionItem;
